import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const SCROLL_THRESHOLD = 320;

function isScrolledPastThreshold() {
  const winY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
  const main = document.getElementById('main-content');
  const mainY = main ? main.scrollTop : 0;
  return winY > SCROLL_THRESHOLD || mainY > SCROLL_THRESHOLD;
}

export default function BackToTopButton() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const update = () => setVisible(isScrolledPastThreshold());
    update();

    window.addEventListener('scroll', update, { passive: true });
    const main = document.getElementById('main-content');
    main?.addEventListener('scroll', update, { passive: true });

    return () => {
      window.removeEventListener('scroll', update);
      main?.removeEventListener('scroll', update);
    };
  }, [pathname]);

  const scrollUp = useCallback(() => {
    const prefersReduced =
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = prefersReduced ? 'auto' : 'smooth';

    window.scrollTo({ top: 0, left: 0, behavior });
    document.documentElement.scrollTo({ top: 0, behavior });
    document.body.scrollTo({ top: 0, behavior });

    const main = document.getElementById('main-content');
    if (main) main.scrollTo({ top: 0, behavior });
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollUp}
      className="fixed bottom-5 right-4 sm:bottom-6 sm:right-6 z-[100] flex h-12 w-12 items-center justify-center rounded-full bg-primary-600 text-white shadow-lg ring-2 ring-white/90 transition hover:bg-primary-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
      aria-label="Revenir en haut de la page"
    >
      <svg
        className="h-6 w-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 10l7-7m0 0l7 7m-7-7v18"
        />
      </svg>
    </button>
  );
}
